import React from 'react'
import {connect} from 'react-redux';

const PRODUCT_CHANNEL = 'pay_channel'
const PRODUCT_LECTURE = 'pay_lecture'

class MinaPay extends  React.Component {
    componentDidMount() {
        const {paySource, minaType, product, id, inviterId, st, sid, discountId, idRecordedLecture} = this.props

        if (!paySource) return

        // 判断小程序支付的来源，默认归“微课推荐”
        let data = minaType ? {mina_type: minaType} : {mina_type: 'popular'}
        data.wk_pay_source = 'mina'

        // 判断优惠券
        if (discountId) {
            data.discount_id = discountId
        }

        // 判断邀请关系
        if (inviterId) {
            data = {
                ...data,
                inviter_id: inviterId,
                st
            }
        }

        if (product === PRODUCT_CHANNEL) {
            data.product = PRODUCT_CHANNEL
            data.channel_id = id
            if (sid) {
                data = {
                    ...data,
                    sid,
                    st: 'channel_cps'
                }
            }
        }

        if (product === PRODUCT_LECTURE) {
            data.product = PRODUCT_LECTURE
            data.lecture_id = id
        }

        // 调起支付
        this.autoPlay = setTimeout(() => {
            this.props.dispatch({
                type: product === PRODUCT_CHANNEL ? 'PAY_CHANNEL' : 'PAY_LECTURE',
                payload: {
                    params: data,
                    success: () => {
                        if (product === PRODUCT_CHANNEL) {
                            location.reload()
                        }

                        if (product === PRODUCT_LECTURE) {
                            if (idRecordedLecture) {
                                location.reload()
                            } else {
                                this.props.dispatch({
                                    type: 'LECTURE_SET_GRANTED',
                                    payload: {
                                        lecture_access: {
                                            granted: true
                                        }
                                    }
                                })
                            }
                        }
                    },
                    fail: () => {
                        console.log('mina pay close....')
                    }
                }
            })
        }, 1000);
    }

    componentWillUnmount() {
        this.autoPlay && clearTimeout(this.autoPlay)
    }

    render() {
        return null
    }
}

export default connect(() => ({
}))(MinaPay)


// WEBPACK FOOTER //
// ./src/components/mina/MinaPay.js